import React from "react";
import { UseFormRegister } from "react-hook-form";
import { ReconciliationFormData } from "../ReconciliationModal";

export interface ProjectMinimumInputProps {
  checked?: boolean;
}

export const ProjectMinimumInput = React.forwardRef<
  HTMLInputElement,
  ProjectMinimumInputProps &
    Partial<ReturnType<UseFormRegister<ReconciliationFormData>>>
>(function BaseProjectMinimumInput({ checked, name, onChange }, ref) {
  return (
    <div className="project-minimum">
      <input
        id="charge-minimum"
        data-testid="charge-minimum-input"
        type="checkbox"
        defaultChecked={checked}
        ref={ref}
        name={name}
        onChange={onChange}
      />
      <label htmlFor="charge-minimum">&nbsp; Charge project minimum ($100)</label>
    </div>
  );
});
